import { NewWebsiteDTO, CustomerUrlModel, ICustomAuthConfigDTO, IUrlCustomAuthConfigClient, IUrlClient, UrlCustomAuthConfigClient, IUrlAuthConfigClient, UrlAuthConfigClient, ICustomerAuthConfigModel, ICustomerUrlModel, SecurityType, CustomerAuthConfigModel, CustomAuthConfigDTO, Secure, CustomerUrlModelSecurityType, CustomerUrlModelSecure, IAuthProviderClient, AuthProviderClient, Auth0CreateDetails, IAuthViewerConfigClient, AuthViewerConfigClient, AuthViewerConfigDTO, IPublishClient, PublishClient } from "@/Generated/ParticaAPI";
import { UrlClient } from "@/Generated/ParticaAPI";

export interface IDomainService {
	addNewWebsite(data: NewWebsiteDTO): Promise<CustomerUrlModel>;
	getWebsite(websiteId: number): Promise<ICustomerUrlModel>;
	getWebsites(customerUrlId: number): Promise<ICustomerUrlModel[]>;
	getCustomConfig(customerUrlId: number): Promise<ICustomAuthConfigDTO>;
	getAuth(customerUrlId: number): Promise<ICustomerAuthConfigModel>;
	updateSecurityType(customerUrlId: number, securityType: CustomerUrlModelSecurityType): Promise<ICustomerUrlModel>;
	saveAuthConfig(authConfig: ICustomerAuthConfigModel): Promise<ICustomerAuthConfigModel>;
	saveCustomAuthConfig(authConfig: ICustomAuthConfigDTO): Promise<ICustomAuthConfigDTO>;
	updateSecure(customerUrlId: number, secure: CustomerUrlModelSecure): Promise<ICustomerUrlModel>;
	createAuthClients(data: Auth0CreateDetails): Promise<any>;
	loadViewerConfig(customerUrlId: number): Promise<AuthViewerConfigDTO>;
	saveViewerConfig(data: AuthViewerConfigDTO): Promise<AuthViewerConfigDTO>;
	publishConfiguration(customerUrlId: number): Promise<any>;
	getAccessToken(urlId: number): Promise<string>;
}

export class DomainService implements IDomainService {

	private svc: IUrlClient = new UrlClient();
	private customsvc: IUrlCustomAuthConfigClient = new UrlCustomAuthConfigClient();
	private auth0svc: IUrlAuthConfigClient = new UrlAuthConfigClient();
	private auth0create: IAuthProviderClient = new AuthProviderClient();
	private viewerConfig: IAuthViewerConfigClient = new AuthViewerConfigClient();
	private publishService: IPublishClient = new PublishClient();

	public async getAccessToken(urlId: number): Promise<string> {
		return await this.svc.getUrlAccessToken(urlId);
	}

	public async publishConfiguration(customerUrlId: number): Promise<any> {
		return await this.publishService.publishUrl(customerUrlId);
	}

	public async loadViewerConfig(customerUrlId: number): Promise<AuthViewerConfigDTO> {
		return await this.viewerConfig.getAuthViewerConfig(customerUrlId);
	}
	public async saveViewerConfig(data: AuthViewerConfigDTO): Promise<AuthViewerConfigDTO> {
		return await this.viewerConfig.saveAuthViewerConfig(data);
	}

	public async createAuthClients(data: Auth0CreateDetails): Promise<any> {
		return await this.auth0create.createAuthClients(data);
	}

	public async addNewWebsite(data: NewWebsiteDTO): Promise<CustomerUrlModel> {
		return await this.svc.addWebsite2(data);
	}

	public async getWebsite(websiteId: number): Promise<CustomerUrlModel> {
		return await this.svc.getURL(websiteId);
	}

	public async getWebsites(customerUrlId: number): Promise<CustomerUrlModel[]> {
		return await this.svc.getUrls(customerUrlId);
	}

	public async getCustomConfig(customerUrlId: number): Promise<ICustomAuthConfigDTO> {
		return await this.customsvc.getAuthConfigForUrl(customerUrlId);
	}

	public async getAuth(customerUrlId: number): Promise<ICustomerAuthConfigModel> {
		return await this.auth0svc.getAuthConfigForUrl(customerUrlId);
	}

	public async updateSecurityType(customerUrlId: number, securityType: CustomerUrlModelSecurityType): Promise<ICustomerUrlModel> {
		return await this.svc.setSecurityType(customerUrlId, securityType as unknown as SecurityType);
	}

	public async updateSecure(customerUrlId: number, secure: CustomerUrlModelSecure): Promise<ICustomerUrlModel> {
		return await this.svc.setUrlSecure(customerUrlId, secure as unknown as Secure);
	}

	public async saveAuthConfig(authConfig: ICustomerAuthConfigModel): Promise<ICustomerAuthConfigModel> {
		return await this.auth0svc.saveAuthConfigForUrl(authConfig as CustomerAuthConfigModel);
	}

	public async saveCustomAuthConfig(authConfig: ICustomAuthConfigDTO): Promise<ICustomAuthConfigDTO> {
		authConfig.callbackUrl = "";
		return await this.customsvc.saveAuthConfigForUrl(authConfig as CustomAuthConfigDTO);
	}

}
